<div class="modal-header">
  <h5 class="modal-title">Add User</h5>
</div>
<div class="modal-body">
  <h6>Select an AzureB2C user</h6>
  <era-security-search-bar [items]="suggestedUsers$ | async"
                           (selectedItem)="enterSelectedItem($event)"></era-security-search-bar>
  <form [formGroup]="addForm">
    <div>
      <label class="form-label"
             for="name"
             class="visually-hidden">Name</label>
      <input type="text"
             placeholder="Name"
             class="form-control mb-1"
             id="displayName"
             formControlName="displayName" />
    </div>
    <div>
      <label class="form-label"
             for="email"
             class="visually-hidden">Email</label>
      <input type="text"
             placeholder="Email"
             class="form-control mb-1"
             id="email"
             formControlName="email" />
    </div>
    <div class="form-group">
      <label for="id"
             class="visually-hidden">Azure B2C Object ID</label>
      <input type="text"
             placeholder="ID"
             class="form-control mb-1"
             id="id"
             formControlName="id" />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-primary"
          (click)="closeModal()">Cancel</button>
  <button class="btn btn-primary"
          [disabled]="addForm.invalid"
          (click)="add()">Create</button>
</div>